var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      class: [
        "alert-item",
        {
          unread:
            _setup.props.alert.visibility ===
            _setup.AlertMessageVisibility.NO_READ,
        },
      ],
      on: {
        click: function ($event) {
          return _setup.goToAlert()
        },
      },
    },
    [
      _c("span", { class: [_setup.props.alert.icon, "lf-icon__lg", "icon"] }),
      _c("div", { staticClass: "item-info" }, [
        _c("span", { staticClass: "alert-text" }, [
          _vm._v(_vm._s(_setup.props.alert.message)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }